// removed by extract-text-webpack-plugin
module.exports = {"sectionImg":"_1A3ZzuO2Bkc0e7JU5xMNY","imgPrez":"_3XifFelUAN3HlnUXP9ipsc"};


//////////////////
// WEBPACK FOOTER
// ./work/lebonchoix/styles.module.css
// module id = 739
// module chunks = 0